import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'table-view',
    pluginName: 'ADMIN',
    entityName: 'TABLE_VIEW',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch grades action creators
export const fetchTableViewsInit = () => {
    return crudActions.fetchInit();
};
export const fetchTableViewStart = () => {
    return crudActions.fetchStart();
};
export const fetchTableViewSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchTableViewFail = () => {
    return crudActions.fetchFail();
};
export const fetchTableViewCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTableViewStart());
        try {
            let countRes = await rest.post("table-view/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchTableViewSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchTableViewFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchTableViewFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch table views."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchTableView = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchTableViewStart());
        try {
            let listRes = await rest.post("table-view/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchTableViewSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchTableViewFail());
            return []

        } catch (error) {
            dispatch(fetchTableViewFail());
            return []
        }
    }
}

// Load table view action creators
export const loadTableViewInit = () => {
    return crudActions.loadInit();
};
export const loadTableViewStart = () => {
    return crudActions.loadStart();
};
export const loadTableViewSuccess = loadedTableView => {
    return crudActions.loadSuccess(loadedTableView);
};
export const loadTableViewFail = error => {
    return crudActions.loadFail(error);
};
export const loadTableView = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

// Create table view action creators
export const createTableViewInit = () => {
    return crudActions.createInit();
};
export const createTableViewStart = () => {
    return crudActions.createStart();
};
export const createTableViewSuccess = createdTableView => {
    return crudActions.createSuccess(createdTableView);
};
export const createTableViewFail = error => {
    return crudActions.createFail(error);
};

export const createTableView = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createTableViewStart());
        try {
            let res = await rest.post('/table-view/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created table view.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createTableViewFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create table view."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create table view."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createTableViewFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit table view action creators
export const editTableViewInit = () => {
    return crudActions.editInit();
};
export const editTableViewStart = () => {
    return crudActions.editStart();
};
export const editTableViewSuccess = editedTableView => {
    return crudActions.editSuccess(editedTableView);
};
export const editTableViewFail = error => {
    return crudActions.editFail(error);
};

export const editTableView = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editTableViewStart());
        try {
            let res = await rest.post('/table-view/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated talbe view.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editTableViewFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit table view."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit table view."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editTableViewFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete grades action creators
export const bulkDeleteTableViewsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteTableViewsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteTableViewsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteTableViewsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteTableViews = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteTableViewsStart());
        try {
            let res = await rest.post('/table-view/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteTableViewsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted table views.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteTableViewsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grades."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete grades."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteTableViewsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};


